import { render, staticRenderFns } from "./profiles_tabs.vue?vue&type=template&id=69b7e712"
import script from "./profiles_tabs.vue?vue&type=script&lang=js"
export * from "./profiles_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports